import {
  createContext,
  useContext,
  useMemo,
  type FC,
  type ReactNode,
} from 'react';

import { useParams } from 'react-router-dom';

interface SandboxContextType {
  selectedSandbox: string;
  gameCode: string;
}

const SandboxContext = createContext<SandboxContextType | undefined>(undefined);

interface SandboxProviderProps {
  children: ReactNode;
}

export const SandboxProvider: FC<SandboxProviderProps> = ({ children }) => {
  const { gameCode, sandboxCode } = useParams<{
    gameCode: string;
    sandboxCode: string;
  }>();
  if (!gameCode || !sandboxCode) {
    throw new Error('Game code and sandbox code are required'); //developer error, should never happen
  }

  const value = useMemo<SandboxContextType>(
    () => ({
      selectedSandbox: sandboxCode,
      gameCode,
    }),
    [sandboxCode, gameCode],
  );

  return (
    <SandboxContext.Provider value={value}>{children}</SandboxContext.Provider>
  );
};

export const useSandboxContext = (): SandboxContextType => {
  const context = useContext(SandboxContext);
  if (context === undefined) {
    throw new Error('useSandboxContext must be used within a SandboxProvider');
  }
  return context;
};
